import "./HomeScreen.css";

import React, { useEffect, useState, useRef, useMemo } from "react";
import { Box, Button, DateInput, DataTable, Menu, Text, Tip } from "grommet";
import HomeScreenService from "./home-screen.service";
import CountCard from "./common/CountCard/CountCard";
import ChartCard from "./common/ChartCard/ChartCard";
import ItemListCard from "./common/ItemListCard/ItemListCard";
import MedicalEmergencyService from "../../../../../services/medical-emergency/medical-emergency.service";

import { Responsive, WidthProvider } from "react-grid-layout";
import VideocallLineChart from "./common/LineChart/VideocallLineChart";
import BarChart from "./common/BarChart/BarChart";
import MapCard from "./common/MapCard/MapCard";
import StandardColors from "../../../../../util/StandardColors";
import { Close, Js } from "grommet-icons";
import { useErrorHandler } from "../../common/context/ErrorStore";
import { observer } from "mobx-react";
import { useStore } from "../../../../../Hooks/useStore";
import { Mixpanel } from "../../../../../util/Helper";
import noActivity from "../../../../../assets/no-activity.png";
import video from "../../../../../assets/videocam.svg";
import chat from "../../../../../assets/sms.svg";
import activityListIcon from "../../../../../assets/Vector.svg";
import filterIcon from "../../../../../assets/filter_list.svg";
import noResult from "../../../../../assets/no-result.png";
import double from "../../../../../assets/double_arrow.svg";
import { toJS } from "mobx";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../../../context/User/UserContext";
import StatusChip from "../../common/status-chip/StatusChip";
import CommonButton from "../../common/Button/CommonButton";
import { MedicalEmergencyStatus } from "../../../../../services/medical-emergency/typings/IMedicalEmergencyApiResponse";
import usersService from "../IAM/Users/users.service";
import { Bar } from "react-chartjs-2";
import UserActivityManager from "../../../../../util/report/UserActivity/UserActivityManager";
import Pagination from "../../common/Pagination/sidebarPagination.tsx/Pagination";
import Utility from "../../../../../util/api/Utility";


const ResponsiveGridLayout = WidthProvider(Responsive);

const HomeScreen = observer(() => {
  const { rootStore } = useStore();
  const activitiesHomeElement = useRef(null);
  const topLeftSection = useRef(null);
  const emergencyFilterRef = useRef(null); // Add ref for emergency filter dropdown
  const activityFilterRef = useRef(null); // Add ref for activity filter dropdown
  const { setUser, user } = useUser();
  const [filterMedicalList, setFilterMedicalList] = useState([]);
  const [initialFilterMedicalList, setInitialFilterMedicalList] = useState([]);
  const [usernames, setUsernames] = useState({});
  const navigate = useNavigate();
  const [videoCallData, setVideoCallData] = useState([]);
  const [sortedList, setSortedList] = useState([]);

  const [chartData, setChartData] = useState({
    labels: ["Diversion required", "Diversion not required"],
    datasets: [
      {
        data: rootStore.adminStore.getDiversionRatio,
        backgroundColor: ["#FFB7B7", "#D1F9E4"],
        borderColor: ["#FFB7B7", "#D1F9E4"],
        borderWidth: 0,
      },
    ],
  });

  // Add useEffect for click-outside detection
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check for emergency filter dropdown
      if (emergencyFilterRef.current && !emergencyFilterRef.current.contains(event.target)) {
        if (rootStore.homeScreenStore.getActiveIncidentFilter) {
          rootStore.homeScreenStore.setActiveIncidentFilter();
        }
      }
      
      // Check for activity filter dropdown
      if (activityFilterRef.current && !activityFilterRef.current.contains(event.target)) {
        if (rootStore.adminHomeStore.getActivityFilter) {
          rootStore.adminHomeStore.setActivityFilter();
        }
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);
    
    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [rootStore.homeScreenStore.getActiveIncidentFilter, rootStore.adminHomeStore.getActivityFilter]);

  useMemo(() => {
    setChartData({
      labels: ["Diversion Required", "Diversion Not Required"],
      datasets: [
        {
          data: rootStore.adminStore.getDiversionRatio,
          backgroundColor: ["#FFB7B7", "#D1F9E4"],
          borderColor: "black",
          borderColor: ["#FFB7B7", "#D1F9E4"],
          borderWidth: 1,
        },
      ],
    });
  }, [rootStore.adminStore.getDiversionRatio]);

  useMemo(() => {
    if (rootStore.adminHomeStore.getVGraphActiveButton == 2) {
      const getMonth = (dateString) => {
        const date = new Date(dateString);
        const monthIndex = date.getMonth();
        return monthIndex;
      };
      let emsData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      let crewData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      let pilotData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      rootStore.adminStore.getVideoTimeLineData.map((videoCall) => {
        let monthIndex = getMonth(videoCall.date);
        if (videoCall.userType == "ems") {
          emsData[monthIndex] += videoCall.count;
        } else if (videoCall.userType == "crew") {
          crewData[monthIndex] += videoCall.count;
        } else if (videoCall.userType == "captain") {
          pilotData[monthIndex] += videoCall.count;
        } else {
        }
      });

      let videoCallData = {
        ems: emsData,
        pilot: pilotData,
        crew: crewData,
      };
      setVideoCallData(videoCallData);
    } else if (rootStore.adminHomeStore.getVGraphActiveButton == 0) {
      const getDayOfWeek = (dateString) => {
        const date = new Date(dateString);
        const dayIndex = date.getDay();
        return dayIndex;
      };
      let emsData = [0, 0, 0, 0, 0, 0, 0];
      let crewData = [0, 0, 0, 0, 0, 0, 0];
      let pilotData = [0, 0, 0, 0, 0, 0, 0];

      rootStore.adminStore.getVideoTimeLineData.map((videoCall) => {
        let monthIndex = getDayOfWeek(videoCall.date);
        if (videoCall.userType == "ems") {
          emsData[monthIndex] += videoCall.count;
        } else if (videoCall.userType == "crew") {
          crewData[monthIndex] += videoCall.count;
        } else if (videoCall.userType == "captain") {
          pilotData[monthIndex] += videoCall.count;
        } else {
        }
      });

      let videoCallData = {
        ems: emsData,
        pilot: pilotData,
        crew: crewData,
      };
      setVideoCallData(videoCallData);
    } else if (rootStore.adminHomeStore.getVGraphActiveButton == 1) {
      // Initialize empty arrays
      const ems = [];
      const captain = [];
      const crew = [];

      // Function to add counts to the respective arrays
      const addToArray = (array, userType, date, count) => {
        let found = false;
        for (let item of array) {
          if (item.date === date && item.count != null) {
            item.count += count;
            found = true;
            break;
          }
        }
        if (!found) {
          array.push({ date: date, count: count });
        }
      };

      // Iterate over the data and update arrays
      rootStore.adminStore.getVideoTimeLineData.forEach((entry) => {
        const { userType, count, date } = entry;
        if (userType === "ems") {
          addToArray(ems, userType, date, count);
        } else if (userType === "captain") {
          addToArray(captain, userType, date, count);
        } else if (userType === "crew") {
          addToArray(crew, userType, date, count);
        }
      });

      // Function to get sorted unique dates
      const getSortedUniqueDates = (arrays) => {
        const dates = new Set();
        arrays.forEach((array) => {
          array.forEach((item) => dates.add(item.date));
        });
        return Array.from(dates).sort();
      };
      const labels = getSortedUniqueDates([ems, crew, captain]);
      const getCountsForDate = (array, date) => {
        const item = array.find((entry) => entry.date === date);
        return item ? item.count : 0;
      };
      const emsFinalData = labels.map((date) => getCountsForDate(ems, date));
      const crewFinalData = labels.map((date) => getCountsForDate(crew, date));
      const captainFinalData = labels.map((date) =>
        getCountsForDate(captain, date)
      );
      let videoCallData = {
        ems: emsFinalData,
        pilot: captainFinalData,
        crew: crewFinalData,
        labels: labels,
      };
      setVideoCallData(videoCallData);
    } else {
    }
  }, [
    rootStore.adminHomeStore.getVGraphActiveButton,
    rootStore.adminStore.getVideoTimeLineData,
  ]);
  // const [homeScreenState, setHomeScreenState] = useState({
  //   flightsCount: 0,
  //   medicalEmergenciesCount: 0,
  //   diversionRatio: { diversionRecommended: 0, notRecommended: 0 },
  //   medicalEmergencyStatusCount: {},
  //   videocallTimelineData: [],
  //   medicalEmergencies: [],
  //   width: 0,
  //   videocallCount: 0,
  //   showFilter: false,
  //   filterDateStart: new Date().toISOString(),
  //   filterDateEnd: new Date().toISOString(),
  //   lastNDays: null,
  // });

  const onActivityFilterClick = () => {
    rootStore.adminHomeStore.setActivityFilter();
  };

  useEffect(() => {
    getActiveUser();
  }, [user]);

  const getActiveUser = async () => {
    if (user) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;
      const day = currentDate.getDate();
      const today = `${year}-${month}-${day}`;
      const projectId =
        process.env.REACT_APP_ENV === "PROD" ? 3370392 : 3210213;
      let activities = await MedicalEmergencyService.getAdminActivity(
        today,
        today,
        projectId
      );
      let data = activities.map((item) => ({
        event: item.event,
        ...item.properties,
      }));
      rootStore.adminHomeStore.setActiveUser(data);
    }
  };

  useEffect(() => {
    const fetchUsernames = async () => {
      const usernamesMap = {};
      for (const item of rootStore.adminHomeStore.getActiveUser) {
        if (item.name) {
          usernamesMap[item.$user_id] = item.name;
        } else {
          try {
            const response = await UserActivityManager.getUserNameByCognitoId(
              item.$user_id
            );
            usernamesMap[item.$user_id] = response.userName;
          } catch (error) {
            console.log(error);
          }
        }
      }
      setUsernames(usernamesMap);
    };

    fetchUsernames();
  }, [rootStore.adminHomeStore.getActiveUser]);

  useEffect(() => {
    getActivity("desc");
  }, [user, rootStore.adminHomeStore.getIncidentList]);

  const getActivity = async (order) => {
    if (user) {
      let ids = rootStore.adminHomeStore.getIncidentList;
      let activities = await MedicalEmergencyService.getActivity(
        user.username,
        ids,
        order
      );
      rootStore.adminHomeStore.setActivity(activities);
    }
  };

  useEffect(() => {
    let endpointRegisterError = localStorage.getItem("registerEndPointError");
    if (endpointRegisterError != null) {
      let error = endpointRegisterError;
      let errorSplitArray = error.split(": ");
      let formattedError = errorSplitArray[1];
      // rootStore.errorHandlingStore.displayError(formattedError);
      localStorage.removeItem("registerEndPointError");
    } else {
      let endpointRegister = localStorage.getItem("isRegister");
      console.log("isendpointRegister", endpointRegister);
      if (endpointRegister != "1") {
        localStorage.setItem("isRegister", "1");
        window.location.reload();
      }
    }
  }, []);

  useEffect(() => {
    // Get counts
    const fetchData = async () => {
      rootStore.loadingStore.setShowLoader(true);
      try {
        // Parallelize independent API calls
        const [
          flightsCount_,
          medicalEmergenciesCount_,
          // diversionRatio,
          statusCounts,
          videocallCount,
          medicalEmergencies_,
        ] = await Promise.all([
          HomeScreenService.getNumberOfFlights(),
          HomeScreenService.getNumberOfMedicalEmergencies(
            rootStore.adminStore.getFilterStartDate,
            rootStore.adminStore.getFilterEndDate
          ),
          // HomeScreenService.getDiversionStatusRatio(),
          HomeScreenService.getMedicalEmergencyStatusCounts(),
          HomeScreenService.getTodaysVideocallCount(),
          MedicalEmergencyService.listMedicalEmergencies(),
        ]);
        rootStore.adminStore.handleFlightCount(flightsCount_);
        if(rootStore.adminStore.getEmergencyCount!==medicalEmergenciesCount_){
          rootStore.adminStore.handleEmergencyCount(medicalEmergenciesCount_);
        }
        // rootStore.adminStore.handleDiversionRatio(diversionRatio);
        rootStore.adminStore.handleMedicalStateStatusCount(statusCounts);
        rootStore.adminStore.handleVideoCount(videocallCount);

        // Filter medical emergencies based on date
        const startDateParsedMillis = new Date(
          Date.parse(rootStore.adminStore.getFilterStartDate)
        ).getTime();
        const endDateParsedMillis = new Date(
          Date.parse(rootStore.adminStore.getFilterEndDate)
        ).getTime();
        const filteredMedicalEmergencies = medicalEmergencies_.filter(
          (medicalEmergency) => {
            const timestampDate = new Date(
              Date.parse(medicalEmergency.timestamp)
            ).getTime();
            return (
              startDateParsedMillis <= timestampDate &&
              timestampDate <= endDateParsedMillis
            );
          }
        );
        rootStore.adminStore.handleMedicalEmergenciesList(
          filteredMedicalEmergencies
        );
      } catch (e) {
        console.error("Error fetching data: ", e);
      } finally {
        rootStore.loadingStore.setShowLoader(false);
      }
    };
    fetchData();
  }, [
    rootStore.adminStore.getFilterStartDate,
    rootStore.adminStore.getFilterEndDate,
    rootStore.adminStore.getEmergencyCount
  ]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust as needed

  const totalItems = initialFilterMedicalList.length;
  // const handlePageChange = (newpage) => {
  //   setCurrentPage(newpage); // Update the current page
  // };

  const handlePageChange = (newPage) => {
    rootStore.loadingStore.setShowLoader(true);
    setCurrentPage(newPage);
    const startIndex = (newPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const getActiveIncidentList = initialFilterMedicalList.slice(
      startIndex,
      endIndex
    );
    setFilterMedicalList(getActiveIncidentList);
    rootStore.adminHomeStore.resetIncidentList();
    getActiveIncidentList.map((item) => {
      rootStore.adminHomeStore.setIncidentId(item.id);
    });
    setTimeout(() => {
      rootStore.loadingStore.setShowLoader(false);
    }, 3000);
  };
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  useEffect(() => {
    // setPeriod(7);
    getWeekDates();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (topLeftSection.current) {
        const height = topLeftSection.current.clientHeight;
        rootStore.adminHomeStore.setActivityHeight(height - 66);
      }
    }, 300);
  }, [filterMedicalList, rootStore.adminHomeStore.getActiveButton]);

  async function getVideoRecord() {
    let startDate = rootStore.adminStore.getFilterStartDate.split("T")[0];
    let endDate = rootStore.adminStore.getFilterEndDate.split("T")[0];
    let videocallTimelineData_ =
      await HomeScreenService.getVideocallTimelineData(
        startDate,
        endDate,
        rootStore.adminHomeStore.getVGraphActiveButton
      );
    console.table(videocallTimelineData_);
    // const videocallTimelineData_ = await HomeScreenService.getVideocallTimelineData2();
    rootStore.adminStore.handleVideocallTimelineData(videocallTimelineData_);
  }
  const options = {
    responsive: true,
    scales: {
      x: {
        stacked: true,
        ticks: {
          display: true,
        },
      },
      y: {
        display: false,
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "bottom",
      },
      layouts: {
        padding: 30,
      },
    },
    barPercentage: 1.0,
    categoryPercentage: 1.0,
  };
  // Bar chart
  const DiversionRecommendation = () => (
    <div style={{ width: "100%", height: "300px" }}>
      <Bar data={chartData} options={options} />
    </div>
  );

  const VideocallsTimeChart = () =>
    videoCallData != null ? (
      <VideocallLineChart
        usertype={rootStore.emsStore.getRoleLabel.toLowerCase()}
        data={videoCallData}
      />
    ) : (
      <Box fill align="center" justify="center">
        <Text color={"black_20"}>No video calls yet</Text>
      </Box>
    );

  const getCurrentMonthDates = () => {
    rootStore.adminHomeStore.handleVGraphActiveButton(1);
    const now = new Date();
    // UTC formate
    const startDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      1
    ).toISOString(); // First day of the current month
    const endDate = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      0
    ).toISOString(); // Last day of the current month
    rootStore.adminStore.handleFilterStartDate(startDate);
    rootStore.adminStore.handleFilterEndDate(endDate);
    getVideoRecord();
  };

  const getWeekDates = (startDay = 0) => {
    rootStore.adminHomeStore.handleVGraphActiveButton(0);
    // startDay is 0 for Sunday, 1 for Monday
    // current date
    const now = new Date();

    // Get the current day of the week (0 = Sunday, 1 = Monday, etc.)
    const currentDay = now.getDay();

    // Calculate the difference between the current day and the start of the week
    const diffToStart = currentDay - startDay;
    const diffToEnd = 6 - startDay - currentDay;

    const startDate = new Date(now);
    startDate.setDate(now.getDate() - diffToStart);

    const endDate = new Date(now);
    endDate.setDate(now.getDate() + diffToEnd);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const day = String(date.getDate()).padStart(2, "0");

      const d = new Date(`${year}-${month}-${day}`).toISOString();
      return d;
    };

    const startDateStr = formatDate(startDate);
    const endDateStr = formatDate(endDate);
    rootStore.adminStore.handleFilterStartDate(startDateStr);
    rootStore.adminStore.handleFilterEndDate(endDateStr);
    getVideoRecord();
  };

  const getStartAndEndOfYear = (year) => {
    rootStore.adminHomeStore.handleVGraphActiveButton(2);
    // Create Date objects for January 1st and December 31st of the specified year
    const startOfYear = new Date(year, 0, 1).toISOString(); // January is month 0
    const endOfYear = new Date(year, 11, 31, 23, 59, 59, 999).toISOString(); // December is month 11

    rootStore.adminStore.handleFilterStartDate(startOfYear);
    rootStore.adminStore.handleFilterEndDate(endOfYear);
    getVideoRecord();
  };

  const onFilterClicked = () => {
    let uInfo = localStorage.getItem("userinfo");
    const userinformation = JSON.parse(uInfo);

    Mixpanel.track("web_home_filter_click", { name: userinformation.username });
    rootStore.adminStore.handleHomeFilter(true);
  };

  const onCloseFilter = () => {
    let uInfo = localStorage.getItem("userinfo");
    const userinformation = JSON.parse(uInfo);
    Mixpanel.track("web_home_filter_close", { name: userinformation.username });
    rootStore.adminStore.handleHomeFilter(false);
  };

  const onExportClicked = async () => {
    let uInfo = localStorage.getItem("userinfo");
    const userinformation = JSON.parse(uInfo);
    Mixpanel.track("web_home_export_click", { name: userinformation.username });
    try {
      rootStore.loadingStore.setShowLoader(true);
      await HomeScreenService.exportInExcel(
        rootStore.adminStore.getFilterStartDate,
        rootStore.adminStore.getFilterEndDate
      );
    } catch (e) {
      rootStore.loadingStore.setShowLoader(false);
    }
    rootStore.loadingStore.setShowLoader(false);
  };

  const onStartFilterDateSelected = ({ value }) => {
    const startDateMillis = new Date(Date.parse(value)).getTime();
    const endDateMillis = new Date(
      Date.parse(rootStore.adminStore.getFilterEndDate)
    ).getTime();

    if (startDateMillis > endDateMillis) {
      rootStore.errorHandlingStore.displayError(
        "Please select start date which is less than or equal to end date"
      );
    } else {
      // rootStore.adminStore.handleLastNDay(null);
      rootStore.adminStore.handleFilterStartDate(value);
      // setHomeScreenState((prev) => {
      //   return {
      //     ...prev,
      //     filterDateStart: value
      //   };
      // });
    }
  };

  const onEndFilterDateSelected = ({ value }) => {
    const startDateMillis = new Date(
      Date.parse(rootStore.adminStore.getFilterStartDate)
    ).getTime();
    const endDateMillis = new Date(Date.parse(value)).getTime();

    if (startDateMillis > endDateMillis) {
      rootStore.errorHandlingStore.displayError(
        "Please select end date which is greater than or equal to start date"
      );
    } else {
      // rootStore.adminStore.handleLastNDay(null);
      rootStore.adminStore.handleFilterEndDate(value);
      // setHomeScreenState((prev) => {
      //   return {
      //     ...prev,
      //     filterDateEnd: value
      //   };
      // });
    }
  };

  let userInfo;
  useEffect(() => {
    (async () => {
      userInfo = localStorage.getItem("userinfo");
      if (userInfo) {
        let roleLabel = JSON.parse(userInfo).roleLabel;
        rootStore.emsStore.handleRoleLabel(roleLabel);
      }
    })();
  }, [userInfo]);

  useEffect(() => {
    activeIncident();
  }, [rootStore.homeScreenStore.getActivityList]);

  const activeIncident = async () => {
    let isAdmin = rootStore.emsStore.getRoleLabel.toLowerCase() == "admin";
    const medicalEmergencies_ =
      await MedicalEmergencyService.listMedicalEmergencies(isAdmin);
    rootStore.adminHomeStore.setActiveIncident(medicalEmergencies_);
  };

  const getTimeWithInfo = (hourCount) => {
    if (hourCount > 12) {
      return "am";
    } else {
      return "pm";
    }
  };

  const getPrettyTime = (date) => {
    let formattedTime = Utility.getFormatedTime(date);
    console.log("formattedTime",formattedTime);
    return formattedTime;
  };

  const getFormatedDate = (givenDate) => {
    let localDateTime = Utility.convertUTCToLocal(givenDate);
    let formattedDate = Utility.getFormatedDate(localDateTime);
    return formattedDate;
  };

  const onEmergencyFilterClick = () => {
    rootStore.homeScreenStore.setActiveIncidentFilter();
  };

  const Columns = [
    {
      property: "Tail Number",
      header: <Text style={{textAlign:"center"}}>Tail Number</Text>,
      primary: true,
      render: (item) => <Text style={{textAlign:"center"}}>{item.flightId}</Text>,
    },
    {
      property: "Date",
      header: <Text style={{textAlign:"center"}}>Date</Text>,
      primary: true,
      render: (item) => {
        return (
          <Text style={{textAlign:"center"}}>{getFormatedDate(item.timestamp)}</Text>
        );
      },
    },
    {
      property: "Time",
      header: <Text style={{textAlign:"center"}}>Time</Text>,
      primary: true,
      render: (item) => (
        <Text style={{textAlign:"center"}}>{getPrettyTime(item.timestamp)}</Text>
      ),
    },
    {
      property: "Status",
      header: <Text style={{textAlign:"center"}}>Status</Text>,
      primary: true,
      render: (item) => (
        <Text style={{textAlign:"center"}}>
          <StatusChip status={item.status} />
        </Text>
      ),
    },
  ];

  const setPeriod = (period) => {
    console.log("time: ", new Date().getTime() - period * 24 * 60 * 60 * 1000);
    const startDate = new Date(
      new Date().getTime() - period * 24 * 60 * 60 * 1000
    ).toISOString();
    const endDate = new Date().toISOString();
    rootStore.adminStore.handleFilterStartDate(startDate);
    rootStore.adminStore.handleFilterEndDate(endDate);
    getVideoRecord();
  };

  const diversionGraphPeriod = (period = 7) => {
    rootStore.loadingStore.setShowLoader(true);
    const startDate = new Date(
      new Date().getTime() - period * 24 * 60 * 60 * 1000
    ).toISOString();
    // const endDate = new Date().toISOString();
    (async () => {
      try {
        let diversionRatio = await HomeScreenService.getDiversionStatusRatio(
          startDate
        );
        rootStore.adminStore.handleDiversionRatio(diversionRatio);
        rootStore.loadingStore.setShowLoader(false);
      } catch (error) {
        console.log(error);
        rootStore.loadingStore.setShowLoader(false);
      }
    })();
  };

  useEffect(() => {
    diversionGraphPeriod(7);
  }, []);

  const layout_large = [
    { i: "header", x: 0, y: 0, w: 5, h: 0.3, static: true },
    { i: "emergency-count", x: 0, y: 0 + 0.4, w: 1, h: 1, static: false },
    { i: "flights-monitored", x: 1, y: 0 + 0.4, w: 1, h: 1, static: false },
    { i: "videocalls-count", x: 2, y: 0 + 0.4, w: 1, h: 1, static: false },
    {
      i: "video-calls",
      x: 0,
      y: 1 + 0.4,
      w: 3,
      h: 1,
      static: false,
    },
    { i: "diversion-recommended", x: 0, y: 2 + 0.4, w: 2, h: 2, static: false },
    { i: "medical-emergencies", x: 3, y: 0 + 0.4, w: 2, h: 2, static: false },
    { i: "map-card", x: 2, y: 2.4, w: 3, h: 2, static: true },
  ];

  const layouts = {
    lg: layout_large,
  };

  useEffect(() => {
    if (activitiesHomeElement.current) {
      activitiesHomeElement.current.scrollTop = 0;
    }
  }, [
    rootStore.adminHomeStore.getActivityList,
    rootStore.adminHomeStore.getFilterAllMedicalIncidentState,
  ]);

  useEffect(() => {
    filterMedical("active");
  }, [rootStore.adminHomeStore.getActiveIncidentList]);

  const filterMedical = (mStatus) => {
    const filterMedicalList =
      rootStore.adminHomeStore.getActiveIncidentList.filter((incident) => {
        if (mStatus == "active") {
          return incident.status !== MedicalEmergencyStatus.RESOLVED;
        } else {
          return incident.status == MedicalEmergencyStatus.RESOLVED;
        }
      });
    rootStore.adminHomeStore.resetIncidentList();
    if (filterMedicalList.length > 0) {
      filterMedicalList.map((item, index) => {
        if (index < 10) {
          rootStore.adminHomeStore.setIncidentId(item.id);
        }
      });
    }
    setFilterMedicalList(filterMedicalList.slice(0, 10));
    setInitialFilterMedicalList(filterMedicalList);
  };

  const IncidentlistFilter = (value) => {
    if (
      value == "new" &&
      rootStore.adminHomeStore.getFilterAllMedicalIncidentState !== "new"
    ) {
      setFilterMedicalList(() => [...filterMedicalList].reverse());
    } else if (
      value == "old" &&
      rootStore.adminHomeStore.getFilterAllMedicalIncidentState !== "old"
    ) {
      setFilterMedicalList(() => [...filterMedicalList].reverse());
    } else {
    }
  };

  const Column = [
    {
      property: "Flight No",
      header: <Text style={{textAlign:"center"}}>UserName</Text>,
      primary: true,
      render: (item) => <p>{item.username}</p>,
    },
    {
      property: "Date",
      header: <Text style={{textAlign:"center"}}>Email</Text>,
      primary: true,
      render: (item) => <p>{item.email}</p>,
    },
    {
      property: "Time",
      header: <Text style={{textAlign:"center"}}>Name</Text>,
      primary: true,
      render: (item) => <p>{item.name}</p>,
    },
    {
      property: "Organization",
      header: <Text style={{textAlign:"center"}}>Organization</Text>,
      primary: true,
      render: (item) => <p>Organization</p>,
    },
    {
      property: "Profile",
      header: <Text style={{textAlign:"center"}}>Profile</Text>,
      primary: true,
      render: (item) => <p>{item["custom:type"]}</p>,
    },
  ];

  const data = [
    {
      property: "Name",
      header: <Text style={{textAlign:"center"}}>Name</Text>,
      primary: true,
      render: (item) => {
        return <p>{usernames[item.$user_id] || "Loading..."}</p>;
      },
    },
    {
      property: "Event Name",
      header: <Text style={{textAlign:"center"}}>Event Name</Text>,
      primary: true,
      render: (item) => <p>{item.event}</p>,
    },
    {
      property: "Medical Assigned",
      header: <Text style={{textAlign:"center"}}>Medical Incident Assigned</Text>,
      primary: true,
      render: (item) => {
        const formattedDateTime = new Date(item.time * 1000);
        // return <p>{formattedDateTime}</p>;
        return <p>{`${getFormatedDate(formattedDateTime)} ${Utility.getFormatedTime(formattedDateTime)}`}</p>;
      },
    },
  ];

  useEffect(() => {
    usersService
      .listUsers()
      .then((_users) => {
        rootStore.adminHomeStore.handleUsers(_users);
        // rootStore.loadingStore.setShowLoader(false);
      })
      .catch((e) => {
        // rootStore.loadingStore.setShowLoader(false);
        rootStore.adminHomeStore.handleUsers([]);
        if (e.message.includes("403")) {
          rootStore.errorHandlingStore.displayError(
            "ERROR: User not authorized"
          );
        }
      });
  }, []);

  useEffect(() => {
    return () => {
      rootStore.adminHomeStore.resetActiveButton();
      rootStore.adminHomeStore.resetFilterAllMedicalIncidentState();
    }
  },[])
  return (
    <>
      <Box className="admin-home-container">
        <Box className="home-container">
          <Box className="left-content" ref={topLeftSection}>
            <Box className="inner">
              <Box className="graph-container">
                <Box
                  direction="row"
                  align="center"
                  justify="between"
                  margin={"0 0 20px 0"}
                >
                  <Text className="heading-txt">Video Calls</Text>
                  <Box direction="row" align="center" justify="between">
                    <Button
                      label="This Week"
                      className={
                        rootStore.adminHomeStore.getVGraphActiveButton == 0
                          ? "time-select-button active"
                          : "time-select-button"
                      }
                      onClick={() => {
                        getWeekDates();
                        // setPeriod(7);
                      }}
                    />
                    <Button
                      label="This month"
                      className={
                        rootStore.adminHomeStore.getVGraphActiveButton == 1
                          ? "time-select-button active"
                          : "time-select-button"
                      }
                      onClick={() => {
                        getCurrentMonthDates();
                        // setPeriod(30);
                      }}
                    />
                    <Button
                      label="This Year"
                      className={
                        rootStore.adminHomeStore.getVGraphActiveButton == 2
                          ? "time-select-button active"
                          : "time-select-button"
                      }
                      onClick={() => {
                        const year = new Date().getFullYear();
                        getStartAndEndOfYear(year);
                        // setPeriod(365);
                      }}
                    />
                  </Box>
                </Box>
                <ChartCard
                  title="Video Calls"
                  chartComponent={VideocallsTimeChart}
                />
              </Box>
              <Box className="card-container">
                <CountCard
                  title="Active Incidents"
                  count={rootStore.adminStore.getEmergencyCount}
                  bgColor="linear-gradient(101deg, #F86161 4.49%, #FE9697 91.67%)"
                />
                <CountCard
                  title="Flights Monitored"
                  count={rootStore.adminStore.getFlightCount}
                  bgColor="linear-gradient(101deg, #1DC387 4.49%, #71EEC0 91.67%)"
                  mt={14}
                />
                <CountCard
                  title="Video-calls Today"
                  count={rootStore.adminStore.getVideoCount}
                  bgColor="linear-gradient(101deg, #D9CC60 4.49%, #F6EB89 91.67%)"
                  mt={14}
                />
              </Box>
            </Box>
            <Box className="active-incident-emergency-list">
              <Box className="heading-row-outer">
                <Text className="active-incident-heading">
                  All Medical Incident
                </Text>
                <Box direction="row" style={{}}>
                  <ul className="button-group">
                    <li>
                      <button style={{cursor:"pointer"}}
                        className={
                          rootStore.adminHomeStore.getActiveButton == "active"
                            ? "active"
                            : ""
                        }
                        onClick={() => {
                          rootStore.adminHomeStore.handleActiveButton("active");
                          filterMedical("active");
                        }}
                      >
                        Active
                      </button>
                    </li>
                    <li>
                      <button
                        style={{ marginLeft: 6, cursor:"pointer" }}
                        className={
                          rootStore.adminHomeStore.getActiveButton == "resolved"
                            ? "active"
                            : ""
                        }
                        onClick={() => {
                          rootStore.adminHomeStore.handleActiveButton(
                            "resolved"
                          );
                          filterMedical("resolved");
                        }}
                      >
                        Resolved
                      </button>
                    </li>
                  </ul>
                  <Box
                    className="filter-icon-shape"
                    onClick={onEmergencyFilterClick}
                    ref={emergencyFilterRef}
                  >
                    <img src={filterIcon} alt="filter icon" />
                    {rootStore.homeScreenStore.getActiveIncidentFilter && (
                      <Box className="dropdown">
                        <ul className="list">
                          <li
                            onClick={() => {
                              IncidentlistFilter("new");
                              rootStore.adminHomeStore.setFilterAllMedicalIncidentState(
                                "new"
                              );
                            }}
                          >
                            Newest
                          </li>
                          <li
                            onClick={() => {
                              IncidentlistFilter("old");
                              rootStore.adminHomeStore.setFilterAllMedicalIncidentState(
                                "old"
                              );
                            }}
                          >
                            Oldest
                          </li>
                        </ul>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
              <Box className="table-outer" style={{ padding: 0 }}>
                <DataTable
                  className="active-incident-emergency-table home-all-medical-incident-table"
                  data={filterMedicalList}
                  resizeable
                  columns={Columns}
                  step={1}
                  onClickRow={({ datum }) => {
                    if (
                      rootStore.emsStore.getRoleLabel.toLowerCase() == "admin"
                    ) {
                      return;
                    }
                    let path = "/ems/medical-emergencies/emergency/" + datum.id;
                    navigate(path);
                  }}
                />
                {filterMedicalList.length == 0 && (
                  <Box className="no-result-img">
                    <img src={noResult} alt="no emergency found" />
                    <p>No active incidents found.</p>
                  </Box>
                )}
              </Box>

              {totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalItems={totalItems}
                  onPageChange={handlePageChange}
                />
              )}
            </Box>
          </Box>
          <Box
            className={
              rootStore.adminHomeStore.getActivityList.length == 0
                ? "right-content empty"
                : "right-content"
            }
          >
            <Box className="activity-header">
              <Box className="heading-outer">
                <Box className="heading-row-outer">
                  <Box className="round-shape">
                    <img src={activityListIcon} />
                  </Box>
                  <Text className="activity-txt">Activities</Text>
                </Box>
                <Box
                  className="filter-icon-shape"
                  onClick={onActivityFilterClick}
                  ref={activityFilterRef}
                >
                  <img src={filterIcon} alt="filter icon" />
                  {rootStore.adminHomeStore.getActivityFilter && (
                    <Box className="dropdown">
                      <ul className="list">
                        <li onClick={() => getActivity("desc")}>Newest</li>
                        <li onClick={() => getActivity("asc")}>Oldest</li>
                      </ul>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>

            <Box
              style={{ height: rootStore.adminHomeStore.getActivityHeight }}
              className="action-card-main"
              ref={activitiesHomeElement}
            >
              {rootStore.adminHomeStore.getActivityList.length > 0 ? (
                rootStore.adminHomeStore.getActivityList.map((activity) => {
                  return <ActivityCard activity={activity} />;
                })
              ) : (
                <Box className="no-activity-history">
                  <img src={noActivity} alt="filter icon" />
                  <Text className="no-activity-txt">
                    No activities to show, start treatment to see flight
                    updates.
                  </Text>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
        {rootStore.emsStore.getRoleLabel.toLowerCase() !== "admin" && (
          <Box className="all-medical-container">
            <Box className="active-incident-emergency-lists">
              <Box className="heading-row-outer">
                <Text className="active-incident-heading">New Added user</Text>
                {/* <p className="active-incident-paragraph">See All <img src={double} /></p> */}
                <div className="active-incident-paragraph">
                  <p
                    onClick={() => {
                      navigate("/users");
                      rootStore.emsStore.handleActiveTab(1);
                    }}
                    className="see-all-link"
                  >
                    See All <img src={double} alt="double" />
                  </p>
                </div>
              </Box>
              <Box className="table-outer">
                <DataTable
                  className="active-incident-emergency-table new-user-table"
                  data={rootStore.adminHomeStore.getUsers.slice(0, 10)}
                  resizeable
                  step={10}
                  columns={Column}
                  style={{
                    marginTop: 14,
                  }}
                />
                {rootStore.adminHomeStore.getUsers.length == 0 && (
                  <Box className="no-result-img">
                    <img src={noResult} alt="no emergency found" />
                    <p>No active incidents found.</p>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        )}
        <Box className="user-graph-wrapper">
          {rootStore.emsStore.getRoleLabel.toLowerCase() !== "admin" && (
            <Box className="new-user-container">
              <Box className="active-incident-emergency-list">
                <Box className="heading-row-outer">
                  <Text className="active-incident-heading">Active User</Text>
                  <div className="active-incident-paragraph">
                    <p
                      onClick={() => {
                        navigate("/user-activity");
                        rootStore.emsStore.handleActiveTab(1);
                      }}
                      className="see-all-link"
                    >
                      See All <img src={double} alt="double" />
                    </p>
                  </div>
                </Box>
                <Box
                  className="table-outer"
                  style={{ padding: 0, height: 300 }}
                  overflow={"auto"}
                >
                  <DataTable
                    className="active-incident-emergency-table active-user"
                    data={rootStore.adminHomeStore.getActiveUser}
                    resizeable
                    step={10}
                    paginate
                    columns={data}
                  />
                  {rootStore.adminHomeStore.getActiveUser.length == 0 && (
                    <Box className="no-result-img">
                      <img src={noResult} alt="no emergency found" />
                      <p>No active incidents found.</p>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          )}
          <Box className="diversion-graph-container">
            <Box
              direction="row"
              align="center"
              justify="between"
              margin={"0 0 20px 0"}
            >
              <Text className="heading-txt">Flight Status</Text>
              <Box direction="row" align="center" justify="between">
                <Button
                  label="This Week"
                  className={
                    rootStore.adminHomeStore.getDGraphActiveButton == 0
                      ? "time-select-button active"
                      : "time-select-button"
                  }
                  onClick={() => {
                    diversionGraphPeriod(7);
                    rootStore.adminHomeStore.handleDGraphActiveButton(0);
                  }}
                />
                <Button
                  label="This month"
                  className={
                    rootStore.adminHomeStore.getDGraphActiveButton == 1
                      ? "time-select-button active"
                      : "time-select-button"
                  }
                  onClick={() => {
                    diversionGraphPeriod(30);
                    rootStore.adminHomeStore.handleDGraphActiveButton(1);
                  }}
                />
                <Button
                  label="This Year"
                  className={
                    rootStore.adminHomeStore.getDGraphActiveButton == 2
                      ? "time-select-button active"
                      : "time-select-button"
                  }
                  onClick={() => {
                    diversionGraphPeriod(365);
                    rootStore.adminHomeStore.handleDGraphActiveButton(2);
                  }}
                />
              </Box>
            </Box>
            <ChartCard
              className="chart-card"
              chartComponent={DiversionRecommendation}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
});

export default HomeScreen;

const ActivityCard = ({ activity }) => {
  const { rootStore } = useStore();
  const navigate = useNavigate();
  const getFormattedDateAndTime = (timeFormat) =>{
    let formattedDateTime
    const unformattedDateGot = Utility.timelog(timeFormat);
    const dateGot = new Date(unformattedDateGot)
    
    const dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$|^\d{4}-\d{1,2}-\d{1,2}$/;
    if (dateRegex.test(dateGot)) {
      const formattedDate = Utility.getFormatedDate(dateGot);
      const formattedTime = Utility.getFormatedTime(dateGot);
      formattedDateTime = `${formattedDate} ${formattedTime}`
    }else{
      formattedDateTime = unformattedDateGot
    }
    return formattedDateTime
  }
  return (
    <div className="activity-card">
      <Text className="medical-incident-title">
        Medical Incident - {activity.medicalEmergencyId}
      </Text>
      <Box className="activity-detail">
        <Box className="person-detail">
          <Box className="picture"></Box>
          <Text className="person-name">{activity.actionBy}</Text>
        </Box>
        <Box className="icons">
          <img
            src={chat}
            className="chat-icon"
            style={{
              opacity:
                rootStore.emsStore.getRoleLabel.toLowerCase() == "admin"
                  ? 0.5
                  : 1,
              pointerEvents:
                rootStore.emsStore.getRoleLabel.toLowerCase() == "admin"
                  ? "none"
                  : "all",
              userSelect:
                rootStore.emsStore.getRoleLabel.toLowerCase() == "admin"
                  ? "none"
                  : "auto",
            }}
            onClick={() =>
              navigate(
                `/ems/medical-emergencies/emergency/${activity.medicalEmergencyId}`
              )
            }
          />
          <img
            src={video}
            className="video-icon"
            style={{
              opacity:
                rootStore.emsStore.getRoleLabel.toLowerCase() == "admin"
                  ? 0.5
                  : 1,
              pointerEvents:
                rootStore.emsStore.getRoleLabel.toLowerCase() == "admin"
                  ? "none"
                  : "all",
              userSelect:
                rootStore.emsStore.getRoleLabel.toLowerCase() == "admin"
                  ? "none"
                  : "auto",
            }}
            onClick={() =>
              navigate(
                `/ems/medical-emergencies/emergency/${activity.medicalEmergencyId}`
              )
            }
          />
        </Box>
      </Box>
      <Box className="report-info">
        <Text>{activity.actionTaken}.</Text>
      </Box>
      {/* <Text className="time-log">{Utility.timelog(activity.timestamp)}</Text> */}
      <Text className="time-log">{getFormattedDateAndTime(activity.timestamp)}</Text>
      <button
        style={{
          opacity:
            rootStore.emsStore.getRoleLabel.toLowerCase() == "admin" ? 0.5 : 1,
          pointerEvents:
            rootStore.emsStore.getRoleLabel.toLowerCase() == "admin"
              ? "none"
              : "all",
          userSelect:
            rootStore.emsStore.getRoleLabel.toLowerCase() == "admin"
              ? "none"
              : "auto",
          cursor:"pointer"
        }}
        onClick={() =>
          navigate(
            `/ems/medical-emergencies/emergency/${activity.medicalEmergencyId}`
          )
        }
        className="check-btn"
      >
        Check
      </button>
    </div>
  );
};
